<script lang="ts" setup>
import { CategoriesProps } from "~/components/Filters/Utils/Modals/Categories.props"
import { CATEGORIES_MODAL } from "~/utils/filters"

const props = defineProps<CategoriesProps>()
const emit =
  defineEmits<{
    (e: "onClose"): void
    (e: "onSelectAll"): void
    (e: "onDeleteAll"): void
    (e: "onApply"): void
  }>()
</script>

<template>
  <FiltersUtilsModalsOptions
    :facet-name="'mainCategory.name'"
    id-facet="mainCategory.name"
    :name="CATEGORIES_MODAL"
    :title="$t('filters.utils.common.categories')"
    :search-item="$t('filters.utils.modals.categories.category')"
    @onClose="emit('onClose')"
    @onSelectAll="emit('onSelectAll')"
    @onDeleteAll="emit('onDeleteAll')"
    @onApply="emit('onApply')"
  />
</template>
